import {convertToPixel} from "./convertToPixel";

const uuid = require("uuid");

export default class SheetTemplate {
    constructor(
       actualSize,
       sheetIndex,
       templateID,
       name,
    ) {
        this.actualSize = actualSize;
        this.sheetIndex = sheetIndex;
        this.templateID = templateID ? templateID : uuid.v4();
        this.name = name ? name : this.displaySize;
        this.canvasSize = {};
        this.ratio = 1;
        this.displaySize = `${actualSize.width} x ${actualSize.height}`
        this.assignCanvasSize();
    }

    assignCanvasSize = () => {
        let { width, height } = this.actualSize;
        const {size, ratio} = convertToPixel(width, height);
        this.canvasSize = size;
        this.ratio = ratio;
    }
}
